export const SCANNER_FIELDS = [
  'symbol',
  'name',
  'price',
  'changePercent',
  'momentumPercentile',
  'growthPercentile',
  'valuePercentile',
  'qualityPercentile',
  'longTermTrend',
  'mediumTermTrend',
  'shortTermTrend',
  'gicsSectorName',
  'marketCap',
  'priceToEarnings',
  'priceToSales',
  'high52Week',
  'low52Week',
];

export const SCANNER_QUERY = {
  fields: SCANNER_FIELDS,
  filtersAsString: 'subtype_in_ADR,COMMON_SHARE,ETF;valuePercentile_bt_,;marketCap_bt_25000000,',
  limit: 40,
  offset: 0,
  sortDir: 1,
  sortField: 'valuePercentile',
};

export const IMAGE_REQUEST_PARAMS = {
  fields: 'mark_light,logo_light',
  scale: '40x40',
  search_keys_type: 'symbol',
};

export const STOCK_SYMBOLS = [
  'NVDA',
  'AAPL',
  'GOOGL',
  'MSFT',
  'GOOG',
  'AMZN',
  'AVGO',
  'META',
  'TSLA',
  'TSM',
  'BRK/A',
  'BRK/B',
  'LLY',
  'WMT',
  'JPM',
  'ORCL',
  'V',
  'XOM',
  'JNJ',
  'MA',
];

export const CRYPTO_SYMBOLS = [
  'BTC',
  'ETH',
  'USDT',
  'XRP',
  'BNB',
  'SOL',
  'USDC',
  'TRX',
  'STETH',
  'DOGE',
  'ADA',
  'WSTETH',
  'WBTC',
  'ZEC',
  'WBETH',
  'HYPE',
  'BCH',
  'LINK',
  'USDS',
  'BSC-USD',
  'LEO',
  'XLM',
  'WETH',
  'WEETH',
  'USDE',
  'LTC',
  'CBBTC',
  'XMR',
];
